import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';

/** @category Instruments */
export function useLockbox(lockboxId?: string) {
  const tokenizedApi = useTokenizedApi();
  const lockboxesById = useQuery(tokenizedApi.treasury.lockboxesQuery())?.data
    ?.idMap;

  if (!lockboxesById || !lockboxId) {
    return;
  }

  return lockboxesById.get(lockboxId);
}
